/**
 *
 * @param firstName
 * @param lastName
 * @returns First name and last name separated with space
 */
export const getFullName = (firstName: string | null | undefined, lastName: string | null | undefined): string => {
  let fullName = '';
  if (firstName) {
    fullName = firstName;
  }
  if (lastName) {
    if (fullName) {
      fullName = fullName + ' ' + lastName;
    } else {
      fullName = lastName;
    }
  }
  return fullName;
};

/**
 *
 * @param person
 * @returns First name and last name separated with space
 */
export const getPersonsFullName = (person: { firstName: string; lastName: string }): string => {
  if (!person) return '';
  const fullName = getFullName(person.firstName, person.lastName);
  return fullName;
};

/**
 * Safely parses integration data that may be either a string or already parsed object
 * @param integrationData - The integration data to parse
 * @returns Parsed object or empty object if parsing fails
 */
export const parseIntegrationData = (integrationData: any): any => {
  if (!integrationData) {
    return {};
  }

  if (typeof integrationData === 'object') {
    return integrationData;
  }

  if (typeof integrationData === 'string') {
    try {
      return JSON.parse(integrationData);
    } catch (error) {
      console.warn('Failed to parse integration data as JSON:', error);
      return {};
    }
  }

  return {};
};

export const noop = (any: any) => {};
